var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5502 14.4001L13.6008 16.0501H11.6009V14.4001C11.6009 13.4507 12.251 12.6499 13.1508 12.4501C15.8674 11.8596 15.6149 7.99696 13.101 7.60009C11.4666 7.27294 10.1008 8.60804 10.1008 10.0502H8.10097C8.10097 7.15679 10.7649 5.10286 13.4511 5.60018C18.0016 6.42677 18.3772 13.2704 13.5502 14.4001H13.5502ZM12.5 16.9998C11.65 16.9998 10.9999 17.6499 10.9999 18.4999C10.9999 19.3499 11.65 20 12.5 20C13.35 20 14.0001 19.3499 14.0001 18.4999C14.0001 17.6499 13.35 16.9998 12.5 16.9998ZM25 12.5C25 19.4001 19.4001 25 12.5 25C5.59991 25 0 19.4001 0 12.5C0 5.59991 5.59991 0 12.5 0C19.4001 0 25 5.59991 25 12.5ZM23.0002 12.5C23.0002 6.69991 18.3001 2 12.5002 2C6.70027 2 2.00018 6.70009 2.00018 12.5C2.00018 18.2999 6.70027 23 12.5002 23C18.3001 23 23.0002 18.2999 23.0002 12.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnigma);
export default __webpack_public_path__ + "static/media/enigma.3227564417b6bd246a51dc017860fbb0.svg";
export { ForwardRef as ReactComponent };